<template>
  <!-- 门店列表 -->
  <div v-loading="loading">
    <div class="content">
      <div class="s_wrapper">
        <el-input class="s_input" placeholder="搜索门店名称" suffix-icon="el-icon-search" v-model="storeName" clearable
          @change="onCurrentPage"></el-input>
        <el-input class="s_input" placeholder="搜索负责人" suffix-icon="el-icon-search" v-model="chargeMan" clearable
          @change="onCurrentPage"></el-input>
        <el-button class="header-btn" type="primary" @click="handleAdd">添加</el-button>
      </div>
      <!-- 表格 -->
      <div class="g_table">
        <el-table max-height="540" :data="tableData">
          <el-table-column label="序号" min-width="60">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="storeName" label="门店名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="totalAddress" label="门店地址" min-width="300" show-overflow-tooltip></el-table-column>
          <el-table-column prop="logoUrl" label="门店logo" show-overflow-tooltip>
            <!-- <el-image style="width: 100px; height: 100px" :src="scope.row.logoUrl" fit="scale-down"></el-image> -->
            <template slot-scope="scope">
              <el-image v-show="false" :preview-src-list="srcList" ref="previewImg"></el-image>
              <div style="color: #069BBC;cursor: pointer;" @click="handleCommandLogo(scope.row.logoUrl)">查看logo</div>
            </template>
          </el-table-column>
          <el-table-column prop="userAccount" label="管理员账号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="chargeMan" label="负责人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="contactTel" label="联系电话" min-width="130" show-overflow-tooltip></el-table-column>
          <el-table-column prop="employCount" label="员工人数" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" fixed="right" min-width="130" align="center">
            <template slot-scope="scope">
              <el-button type="primary" plain size="small" @click="handleEdit(scope.row)">修改</el-button>
              <el-button size="small" type="primary" @click="handleDel(scope.row)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
        layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
        <el-form-item label="门店logo" prop="logoUrl" class="logo_pic">
          <div class="pic-row">
            <div class="pic">
              <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
                :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUploads"
                :on-remove="handleRemoveLogo">
                <img v-if="ruleForm.logoUrl" :src="ruleForm.logoUrl" class="logoimg" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="门店名称" prop="storeName">
          <el-input v-model.trim="ruleForm.storeName" placeholder="请输入门店名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="门店地址省市区" prop="province">
          <el-cascader :options="areaData" placeholder="请选择门店省市区" v-model="selectedAddresses"
            @change="handleChangeAddress" :props="{
              expandTrigger: 'hover',
            }" clearable>
          </el-cascader>
        </el-form-item>
        <el-form-item label="门店详细地址" prop="address">
          <el-input v-model.trim="ruleForm.address" resize="none" style="width: 52%;" type="textarea" :rows="3"
            placeholder="请输入门店详细地址" clearable></el-input>
        </el-form-item>
        <el-form-item label="门店负责人" prop="chargeMan">
          <el-input v-model.trim="ruleForm.chargeMan" placeholder="请输入门店负责人" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactTel">
          <el-input v-model.trim="ruleForm.contactTel" placeholder="请输入联系电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="员工人数" prop="employCount">
          <el-input v-model.trim="ruleForm.employCount" placeholder="请输入员工人数" clearable></el-input>
        </el-form-item>
        <el-form-item label="管理员账号" prop="userAccount">
          <el-input v-model.trim="ruleForm.userAccount" placeholder="请输入管理员账号" clearable></el-input>
        </el-form-item>
        <el-form-item label="管理员密码" prop="userPassword">
          <el-input v-model.trim="ruleForm.userPassword" :placeholder="dialogTitle == '修改门店' ? '请输入新密码' : '请输入管理员密码'"
            clearable onkeyup="value = value.replace(/[\u4e00-\u9fa5]/g, '')"></el-input>
          <el-tooltip effect="light" :content="tooltipContent" placement="right">
            <i class="el-icon-warning-outline" style="margin-left: 10px"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="门店简介" prop="introduce">
          <el-input resize="none" style="width: 80%;" type="textarea" :rows="6" v-model.trim="ruleForm.introduce"
            placeholder="请输入门店简介" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="dialogLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      // 表格数据
      tableData: [],
      srcList: [],
      dialogVisible: false, //弹窗隐显
      dialogLoading: false, //弹窗按钮Loading
      dialogTitle: "", //弹窗标题
      areaData: [],//地址原始数据
      selectedAddresses: [],//地址当前选择数据数组
      ruleForm: {
        storeName: "", //门店名称
        province: '', //省
        city: '', //市
        area: '', //区
        provinceCode: '', //省
        cityCode: '', //市
        areaCode: '', //区
        address: "", //门店详细地址
        chargeMan: "", //门店负责人
        contactTel: "", //联系电话
        employCount: "", //员工人数
        userAccount: "", //管理员账号
        userPassword: "", //管理员密码第一次
        introduce: "", //门店简介
        logoUrl: "", //门店logo
      },
      tooltipContent: "密码至少 8 位数！", //管理员密码提示
      rules: {
        storeName: [{ required: true, message: "请输入门店名称", trigger: "blur" }],
        address: [{ required: true, message: "请输入门店详细地址", trigger: "blur" }],
        province: [{ required: true, message: "请选择门店省市区", trigger: "blur" }],
        chargeMan: [{ required: true, message: "请输入门店负责人", trigger: "blur" }],
        introduce: [{ required: true, message: "请输入门店简介", trigger: "blur" }],
        contactTel: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$|^(0[0-9]{2,3}-)?([2-9][0-9]{6,7})+(-\d{1,4})?$/,
            message: "请输入正确的电话号码格式",
            trigger: "blur",
          },
        ],
        employCount: [
          { required: true, message: "请输入员工人数", trigger: "blur" },
          { pattern: /^[1-9]\d*$/, message: "请输入正确员工人数", trigger: "blur" },
        ],
        userAccount: [
          { required: true, message: "请输入管理员账号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$|^(0[0-9]{2,3}-)?([2-9][0-9]{6,7})+(-\d{1,4})?$/,
            message: "请输入正确的电话号码格式",
            trigger: "blur",
          },
        ],
        userPassword: [
          { required: true, message: "请输入管理员密码", trigger: "blur" },
          { min: 8, message: "密码至少为 8 位数", trigger: "change" },
        ],
        logoUrl: [{ required: true, message: "请上传门店logo", trigger: "change" }],
      },
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      // 分页器
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50],
      totalCount: 0, // 总记录数据
      storeName: "", //门店名称
      chargeMan: "", //负责人
      storeId: "",
    }
  },
  created() {
    this.getRequest() //请求数据
    this.getRequestAddress()
  },
  methods: {
    // 请求
    getRequest() {
      this.loading = true
      this.$axios
        .get(this.$api.selectStoreInfoList, {
          params: {
            chargeMan: this.chargeMan || null, //负责人
            storeName: this.storeName || null, //门店名称
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          const { code, result } = res
          if (code == 100) {
            this.totalCount = result.totalCount
            this.tableData = result.list
            this.loading = false
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 地址请求
    getRequestAddress() {
      this.$axios
        .get(this.$api.storeAddAddress)
        .then(res => {
          const { code, result } = res
          if (code == 100) {
            this.areaData = result.map((item) => {
              return {
                label: item.name,
                value: item.code,
                children: item.children.map((element) => {
                  return {
                    label: element.name,
                    value: element.code,
                    children: element.children.map((val) => {
                      return {
                        label: val.name,
                        value: val.code
                      };
                    })
                  };
                })
              };
            });
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 添加门店
    handleAdd() {
      this.ruleForm = {}
      this.selectedAddresses = ''//省市区清空
      this.dialogTitle = "添加门店"
      this.dialogVisible = true
    },
    // 提交门店信息
    async submitForm(formName) {
      try {
        // 校验表单
        await new Promise((resolve, reject) => {
          this.$refs[formName].validate(valid => {
            if (!valid) {
              this.$message.error("请检查门店信息是否漏填！")
              this.dialogLoading = false
              return
            } else {
              resolve() // 校验成功
            }
          })
        })
        // 要发送的数据
        const data = {
          storeName: this.ruleForm.storeName,
          province: this.ruleForm.province,
          city: this.ruleForm.city,
          area: this.ruleForm.area,
          provinceCode: this.ruleForm.provinceCode,
          cityCode: this.ruleForm.cityCode,
          areaCode: this.ruleForm.areaCode,
          address: this.ruleForm.address,
          chargeMan: this.ruleForm.chargeMan,
          contactTel: this.ruleForm.contactTel,
          employCount: this.ruleForm.employCount,
          userAccount: this.ruleForm.userAccount,
          userPassword: this.ruleForm.userPassword,
          logoUrl: this.ruleForm.logoUrl,
          introduce: this.ruleForm.introduce,
          storeId: this.storeId || null,
        }
        // console.log(data);
        // 根据状态决定是添加还是修改
        let response
        let message
        if (this.dialogTitle == "添加门店") {
          message = "恭喜你，添加成功!"
          response = await this.$axios.post(this.$api.addStoreList, data)
        } else {
          message = "恭喜你，修改成功!"
          response = await this.$axios.post(this.$api.editStoreList, data)
        }

        // 处理响应结果
        const { code } = response
        if (code == 100) {
          this.onCurrentPage() // 调取列表数据
          this.loading = false
          this.$message({ message: message, type: "success" })
          this.dialogLoading = false
          this.dialogVisible = false
          this.resetForm() // 重置校验
        }
      } catch (err) {
        this.$message.error(err.desc)
        this.loading = false
      }
    },
    // 选择省市区
    handleChangeAddress(val) {
      // console.log('所选门店的省市区编码：', val);
      this.filterDataByValue(this.areaData, val);
    },
    // 通过编码匹配省市区
    filterDataByValue(dataArray, value) {
      for (let index = 0; index < dataArray.length; index++) {
        const element = dataArray[index];
        if (value[0] == element.value) {
          // console.log('省名', element.label);
          // console.log('省编码', element.value);
          this.ruleForm.province = element.label
          this.ruleForm.provinceCode = element.value
          if (element.children && value.length > 1) {
            for (let index = 0; index < element.children.length; index++) {
              const item = element.children[index];
              if (value[1] == item.value) {
                // console.log('市名', item.label);
                // console.log('市编码', item.value);
                this.ruleForm.city = item.label
                this.ruleForm.cityCode = item.value
                if (item.children && value.length > 2) {
                  for (let index = 0; index < item.children.length; index++) {
                    const val = item.children[index];
                    if (value[2] == val.value) {
                      // console.log('区名', val.label);
                      // console.log('区编码', val.value);
                      this.ruleForm.area = val.label
                      this.ruleForm.areaCode = val.value
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    // 取消按钮
    handleCancel() {
      this.dialogVisible = false
    },

    // 表单重置
    resetForm() {
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields()
    },
    // 删除
    handleDel(row) {
      this.$confirm("此操作将永久删除该门店信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deleteStoreList, {
              params: {
                storeId: row.storeId,
              },
            })
            .then(res => {
              if (res.code == 100) {
                this.onCurrentPage()
                this.$message.success("删除成功！")
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除操作",
          })
        })
    },
    //修改
    handleEdit(row) {
      this.dialogTitle = "修改门店"
      this.dialogVisible = true
      this.$axios
        .get(this.$api.selectStoreInfo, {
          params: {
            storeId: row.storeId,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.ruleForm = res.result
            this.storeId = row.storeId
            this.$set(this.ruleForm, 'userAccount', row.userAccount)
            this.$set(this.ruleForm, 'userPassword', '********')
            this.selectedAddresses = [res.result.provinceCode, res.result.cityCode, res.result.areaCode]
            this.onCurrentPage()
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })


    },
    // 上传成功
    handleSuccess(res) {
      const { code, result } = res
      if (code == 100) {
        this.$set(this.ruleForm, 'logoUrl', result.fileUrl)
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error" })
      }
    },
    // 上传前检查
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 删除
    handleRemoveLogo() {
      // this.ruleForm.logoUrl = ""
      this.$set(this.ruleForm, 'logoUrl', '')

    },
    // 查看logo图片
    handleCommandLogo(imageUrl) {
      if (imageUrl) {
        this.srcList = [imageUrl];
        this.$refs.previewImg.showViewer = true;
      } else {
        this.$message.error("未上传门店logo!");
      }
    },
    // 分页器
    onCurrentPage() {
      this.tableData = []
      this.currentPage = 1
      this.getRequest()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onCurrentPage()
    },
    handleCurrentChange(val) {
      this.tableData = []
      this.currentPage = val
      this.getRequest()
    },
  },
}
</script>

<style scoped lang="scss">
.pagination {
  margin-top: 20px;
}

.content {


  .el-date-editor {
    margin-left: 10px !important;
  }

  .header-btn {
    margin-left: 10px;
  }
}

// 图片
.logo_pic {
  position: relative;

  ::v-deep .el-form-item__content {
    width: 100px;
    height: 100px;
  }

  .pic-row {
    display: flex;

    .pic {
      margin-right: 15px;

      .logo_uploader {
        ::v-deep .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        ::v-deep .el-upload:hover {
          border-color: #069bbc;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #069bbc;
          width: 100px;
          height: 100px;
          line-height: 100px;
          text-align: center;
        }

        .logoimg {
          width: 100px;
          height: 100px;
          display: block;
          object-fit: cover;
        }
      }
    }
  }

  // .delpic {
  //   position: absolute;
  //   top: -12px;
  //   color: red;
  //   font-size: 20px;
  //   cursor: pointer;
  // }

  // .delpic1 {
  //   right: -15px;
  // }

  // .delpic2 {
  //   right: -134px;
  // }

  // .delpic3 {
  //   right: -250px;
  // }
}

/*操作下拉框内容*/
.el-dropdown-link {
  cursor: pointer;
}

::v-deep .el-dialog .el-input,
::v-deep .el-dialog .el-input__inner {
  width: 400px;
}
</style>
